import { render, staticRenderFns } from "./DataTableLiquidacionCorredor.vue?vue&type=template&id=67fd10ac&"
import script from "./DataTableLiquidacionCorredor.vue?vue&type=script&lang=js&"
export * from "./DataTableLiquidacionCorredor.vue?vue&type=script&lang=js&"
import style0 from "./DataTableLiquidacionCorredor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VIcon,VPagination})
